import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import StartPage from './routes/start';

import './utils.scss';
import './style.scss';
import { getTrackRoute } from './routes/routes';
import TrackPage from './routes/track';
import ResultPopup from './components/result-popup';
import ScrollToTop from './utils/scroll-to-top';
import ClockSetter from './components/clock/clock-setter';
import ResetPage from './routes/reset';
import useEndingPopupCheck from './modules/result-popup/hooks/use-ending-popup-check';
import useCompleteGameCheck from './modules/user/hooks/use-complete-game';

export default function App() {

    useEndingPopupCheck();
    useCompleteGameCheck();

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <ScrollToTop />
            <Switch>
                <Route path="/" exact>
                    <ClockSetter />
                    <StartPage />
                </Route>
                <Route path={getTrackRoute()} exact>
                    <ClockSetter />
                    <TrackPage />
                </Route>
                {/* <Route path={getNodeRoute()} exact>
                    <NodePage />
                </Route> */}
                <Route path='/reset' exact>
                    <ResetPage />
                </Route>
            </Switch>
            <footer>
                <div className="sponsors">
                    <nav className="page-container row">
                        <a href="http://"><img src={`${process.env.PUBLIC_URL}/images/logo/szkola.png`} alt="" /></a>
                        <a href="http://"><img src={`${process.env.PUBLIC_URL}/images/logo/scek.png`} alt="" /></a>
                        <a href="http://"><img src={`${process.env.PUBLIC_URL}/images/logo/warszawa.png`} alt="" /></a>
                    </nav>
                </div>
                <section className="socials">
                    <nav className="page-container row">
                        <a className='fb' href="http://"><img src={`${process.env.PUBLIC_URL}/images/fb.png`} alt="Facebook" /></a>
                        <a className='instagram' href="http://"><img src={`${process.env.PUBLIC_URL}/images/instagram.png`} alt="instagram" /></a>
                    </nav>
                </section>
            </footer>
            <ResultPopup />
        </BrowserRouter>
    )
}
